import styled from 'styled-components'

export const TabNav = styled.div`
  display: flex;
  height: 2.875rem;
  flex-shrink: 0;
  border-bottom: 1px solid ${props => props.theme.borderColor};
  padding: 0 0.625rem;
  align-items: stretch;
  z-index: 3;
`

export const TabItem = styled.span`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 0.875rem;
  border-width: 0 0 0.0975rem 0;
  border-style: solid;
  border-bottom-color: ${props => (props.$active ? props.$themeColor : 'transparent')};
  color: ${({ theme, $hoverBackground }) => theme.bsBodyColor};
  padding: 0.45rem 0.65rem;
  border-radius: 0;
  transition: 0.3s;
  opacity: ${props => (props.$active ? '1' : '.65')};
  &:hover {
    border-bottom-color: ${({ theme, $active, $themeColor, $hoverBackground }) =>
      $active
        ? $hoverBackground
          ? 'transparent'
          : $themeColor
        : $hoverBackground
          ? 'transparent'
          : theme.tabNavHoverBorderColor};
    background-color: ${({ theme, $hoverBackground }) => ($hoverBackground ? theme.hoverBgLightestInverse : 'transparent')};
    border-radius: 0;
    opacity: 0.9;
  }
  > * + * {
    margin: 0 0 0 0.25rem;
  }
  a {
    display: inline-flex;
    align-items: center;
    align-self: stretch;
    color: inherit;
    text-decoration: none;
    width: 100%;
    cursor: pointer;
  }
  span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`
